const { onlyNumericNormalize, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumericNormalize(zipCode);
  if (zipCode.length <= 2) {
    return zip;
  }
  return `${zip.slice(0, 2)}-${zip.slice(2, 5)}`;
};

exports.countryDefinition = {
  country: 'Poland',
  code: 'PL',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[0-9]{2}-[0-9]{3}$/),
      error: 'Must be 2+3 numbers, 00-950'
    }
  ]
};
